/**
 * Created by toomasp on 31.07.2015.
 */
export class ViewportController {
    static $inject = ['loaderContext'];

    constructor(public loaderContext) {
    }
}


// WEBPACK FOOTER //
// ./src/main/ui/core/components/viewport/viewport.controller.ts